// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__T0psY","container":"Footer_container__R7sXj","linkWrapper":"Footer_linkWrapper__4tjWo"};